// extracted by mini-css-extract-plugin
module.exports = {"paragraph":"paragraph-module--paragraph--3mYro"};